



























































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import * as api from '@/store/api';
import user from '@/store/modules/user';
import TemplateSelection from '@/views/TemplateSelection.vue';

@Component({components: {TemplateSelection}})
export default class EditSie extends Vue {
    sie: any = {};
    plModel: any = [
        { type: 'pl',     field: 'NetSales',                 title: 'Nettoomsättning' },
        { type: 'pl',     field: 'ChangeInventWorkProg',     title: 'Förändring av varulager' },
        { type: 'pl',     field: 'WorkPerfOwnUseCapital',    title: 'Aktiverat arbete för egen räkning' },
        { type: 'pl',     field: 'OtherOppIncome',           title: 'Övriga rörelseintäkter' },
        { type: 'sum',    field: 'NetOperatingIncome',       title: 'Summa intäkter' },
        { type: 'pl',     field: 'RawMatAndCons',            title: 'Kostnader för varor och material' },
        { type: 'pl',     field: 'OtherExtCosts',            title: 'Övriga externa kostnader' },
        { type: 'pl',     field: 'PersonalCosts',            title: 'Personalkostnader' },
        { type: 'pl',     field: 'OtherOppExpenses',         title: 'Övriga rörelsekostnader' },
        { type: 'pl',     field: 'DeprAndWriteDowns',        title: 'Av- och nedskrivningar' },
        { type: 'sum',    field: 'OperatingResult',          title: 'Rörelseresultat' },
        { type: 'pl',     field: 'ResultParticipationGroup', title: 'Intäkter från koncern & intresseföretag' },
        { type: 'pl',     field: 'ExtInterestInc',           title: 'Externa ränteintäkter' },
        { type: 'pl',     field: 'FinIntGroupInc',           title: 'Ränteintäkter från koncern & intresseföretag' },
        { type: 'pl',     field: 'OtherFinInc',              title: 'Övriga finansiella intäkter' },
        { type: 'pl',     field: 'InterestExpExt',           title: 'Externa räntekostnader' },
        { type: 'pl',     field: 'InterestExpInt',           title: 'Räntekostnader från koncern & intresseföretag' },
        { type: 'pl',     field: 'OtherFinCosts',            title: 'Övriga finansiella kostnader' },
        { type: 'sum',    field: 'ProfLossAfterFinItems',    title: 'Resultat efter finansiella poster' },
        { type: 'pl',     field: 'GroupContrib',             title: 'Koncernbidrag' },
        { type: 'pl',     field: 'OtherAppropriations',      title: 'Bokslutsdispositioner' },
        { type: 'pl',     field: 'Tax',                      title: 'Skatt på årets resultat' },
        { type: 'sum',    field: 'NetProfitLoss',            title: 'ÅRETS RESULTAT' },
    ];
    bsModel: any = [
        { type: 'title',  field: '1',                        title: 'TILLGÅNGAR' },
        { type: 'bs',     field: 'SubscribedCapitalUnpaid',  title: 'Tecknat men ej inbetalt kapital' },
        { type: 'title',  field: '2',                        title: 'Anläggningstillgångar' },
        { type: 'bs2',    field: 'TotalIntangibleAssets',    title: 'Immateriella anläggningstillgångar' },
        { type: 'bs2',    field: 'TotalTangibleAssets',      title: 'Materiella anläggningstillgångar' },
        { type: 'bs2',    field: 'TotalFinancialAssets',     title: 'Finansiella anläggningstillgångar' },
        { type: 'sum',    field: 'TotFixAssets',             title: 'Summa anläggningstillgångar' },
        { type: 'title',  field: '3',                        title: 'Omsättningstillgångar' },
        { type: 'bs2',    field: 'WorkOnContract',           title: 'Pågående arbete för annans räkning' },
        { type: 'bs2',    field: 'Inventories',              title: 'Varulager' },
        { type: 'bs2',    field: 'AccountsReceivableTrade',  title: 'Kundfordringar' },
        { type: 'bs2',    field: 'AccRecieveGroup',          title: 'Fordringar koncern & intresseföretag' },
        { type: 'bs2',    field: 'OtherAccRecieve',          title: 'Övriga kortfristiga fordringar' },
        { type: 'bs2',    field: 'ShortInvestments',         title: 'Kortfristiga placeringar' },
        { type: 'bs2',    field: 'CashAndBankBalances',      title: 'Kassa och bank' },
        { type: 'bs2',    field: 'OtherCurAssets',           title: 'Övriga omsättningstillgångar' },
        { type: 'sum',    field: 'TotalTurnoverAssets',      title: 'Summa omsättningstillgångar' },
        { type: 'sum',    field: 'TotAssets',                title: 'SUMMA TILLGÅNGAR' },

        { type: 'title',  field: '4',                        title: 'EGET KAPITAL OCH SKULDER' },
        { type: 'pldiff', field: '5',                        title: 'Resultatförändring (ingår i Eget kapital)' },
        { type: 'bs',     field: 'TotEquity',                title: 'Eget kapital' },
        { type: 'bs',     field: 'UntaxedReserves',          title: 'Obeskattade reserver' },
        { type: 'bs',     field: 'Provisions',               title: 'Avsättningar' },
        { type: 'bs',     field: 'TotLongTermDebts',         title: 'Långfristiga skulder' },
        { type: 'bs',     field: 'TotCurrentLiabilities',    title: 'Kortfristiga skulder' },
        { type: 'sum',    field: 'TotEquityAndLiab',         title: 'SUMMA EGET KAPITAL OCH SKULDER' },
    ];
    NetProfitLossDiff: number = 0;
    TotAssets: number = 0;
    TotAssetsDiff: number = 0;
    TotEquityAndLiab: number = 0;
    TotEquityAndLiabDiff: number = 0;

    initialUnbalance: boolean = false;

    async mounted() {
        if (user.selectedSieBlob) {
            this.sie = await api.getSie(user.selectedSieBlob);
            this.initialUnbalance = this.getSum({field: 'TotAssets'}) !== this.getSum({field: 'TotEquityAndLiab'});
        }
        if (!this.bs) {
            await this.$router.push({name: 'start'});
        }
    }

    getValue(item: any): number {
        return Number(this.getValueRaw(item));
    }

    getValueRaw(item: any): string {
        if (item.type === 'pl') {
            return this.pl[item.field];
        }
        if (item.type === 'bs' || item.type === 'bs2') {
            return this.bs[item.field];
        }
        return '0';
    }

    getSum(item: any): number {
        switch (item.field) {
            case 'NetOperatingIncome':
                return this.sum(this.pl,
                    ['NetSales', 'ChangeInventWorkProg', 'WorkPerfOwnUseCapital', 'OtherOppIncome']);
            case 'OperatingResult':
                return this.getSum({field: 'NetOperatingIncome'}) + this.sum(this.pl,
                    ['RawMatAndCons', 'OtherExtCosts', 'PersonalCosts', 'OtherOppExpenses', 'DeprAndWriteDowns']);
            case 'ProfLossAfterFinItems':
                return this.getSum({field: 'OperatingResult'}) + this.sum(this.pl,
                    ['ResultParticipationGroup', 'ExtInterestInc', 'FinIntGroupInc', 'OtherFinInc', 'InterestExpExt',
                        'InterestExpInt', 'OtherFinCosts']);
            case 'NetProfitLoss':
                return this.getSum({field: 'ProfLossAfterFinItems'}) + this.sum(this.pl,
                    ['GroupContrib', 'OtherAppropriations', 'Tax']);
            case 'TotFixAssets':
                return this.sum(this.bs,
                    ['SubscribedCapitalUnpaid', 'TotalIntangibleAssets',
                        'TotalTangibleAssets', 'TotalFinancialAssets']);
            case 'TotalTurnoverAssets':
                return this.sum(this.bs,
                    ['WorkOnContract', 'Inventories', 'AccountsReceivableTrade',
                    'AccRecieveGroup', 'OtherAccRecieve', 'ShortInvestments', 'CashAndBankBalances', 'OtherCurAssets']);
            case 'TotAssets':
                this.TotAssets = this.getSum({field: 'TotFixAssets'}) + this.getSum({field: 'TotalTurnoverAssets'});
                return this.TotAssets;
            case 'TotEquityAndLiab':
                this.TotEquityAndLiab = this.sum(this.bs,
                    ['TotEquity', 'UntaxedReserves', 'Provisions',
                        'TotLongTermDebts', 'TotCurrentLiabilities']);
                return this.TotEquityAndLiab;
        }
        return 0;
    }

    sum(source: any, fields: string[]): number {
        let sum = 0;
        for (const field of fields) {
            sum += Number(source[field]);
        }
        return sum;
    }

    getDiff(item: any): number {
        switch (item.field) {
            case 'NetOperatingIncome':
                return this.diff(this.plModel,
                    ['NetSales', 'ChangeInventWorkProg', 'WorkPerfOwnUseCapital', 'OtherOppIncome']);
            case 'OperatingResult':
                return this.getDiff({field: 'NetOperatingIncome'}) + this.diff(this.plModel,
                    ['RawMatAndCons', 'OtherExtCosts', 'PersonalCosts', 'OtherOppExpenses', 'DeprAndWriteDowns']);
            case 'ProfLossAfterFinItems':
                return this.getDiff({field: 'OperatingResult'}) + this.diff(this.plModel,
                    ['ResultParticipationGroup', 'ExtInterestInc', 'FinIntGroupInc', 'OtherFinInc', 'InterestExpExt',
                        'InterestExpInt', 'OtherFinCosts']);
            case 'NetProfitLoss':
                this.NetProfitLossDiff = this.getDiff({field: 'ProfLossAfterFinItems'}) + this.diff(this.plModel,
                    ['GroupContrib', 'OtherAppropriations', 'Tax']);
                return this.NetProfitLossDiff;
            case 'TotFixAssets':
                return this.diff(this.bsModel,
                    ['SubscribedCapitalUnpaid', 'TotalIntangibleAssets',
                        'TotalTangibleAssets', 'TotalFinancialAssets']);
            case 'TotalTurnoverAssets':
                return this.diff(this.bsModel,
                    ['WorkOnContract', 'Inventories', 'AccountsReceivableTrade',
                        'AccRecieveGroup', 'OtherAccRecieve', 'ShortInvestments', 'CashAndBankBalances', 'OtherCurAssets']);
            case 'TotAssets':
                this.TotAssetsDiff =
                    this.getDiff({field: 'TotFixAssets'}) + this.getDiff({field: 'TotalTurnoverAssets'});
                return this.TotAssetsDiff;
            case 'TotEquityAndLiab':
                this.TotEquityAndLiabDiff = this.diff(this.bsModel,
                    ['TotEquity', 'UntaxedReserves', 'Provisions',
                        'TotLongTermDebts', 'TotCurrentLiabilities']) + this.NetProfitLossDiff;
                return this.TotEquityAndLiabDiff;
        }
        return 0;
    }

    diff(source: any, fields: string[]): number {
        let diff = 0;
        for (const field of fields) {
            for (const item of source) {
                if (item.field === field) {
                    if (item.value) {
                        diff += Number(item.value) - this.getValue(item);
                    }
                    break;
                }
            }
        }
        if (diff !== 0) {
            this.initialUnbalance = false;
        }
        return diff;
    }

    newSum(field: string): string {
        return '' + (this.getSum({field}) + this.getDiff({field}));
    }

    newVal(field: string): string {
        for (const source of [this.plModel, this.bsModel]) {
            for (const item of source) {
                if (item.field === field) {
                    if (item.value) {
                        return item.value;
                    } else {
                        return this.getValueRaw(item);
                    }
                }
            }
        }
        return '0';
    }

    filterInput(event: any) {
        if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'].indexOf(event.key) === -1) {
            event.preventDefault();
        }
    }

    prev() {
        this.$router.back();
    }

    async update() {
        if (!this.canCreate) {
            return;
        }

        const doc = {
            Version: 1,
            SieId: user.selectedSie,
            Profitloss: {
                DateFrom: this.pl.DateFrom,
                DateTo: this.pl.DateTo,
                Months: this.pl.Months,
                NetSales: this.newVal('NetSales'),
                ChangeInventWorkProg: this.newVal('ChangeInventWorkProg'),
                WorkPerfOwnUseCapital: this.newVal('WorkPerfOwnUseCapital'),
                OtherOppIncome: this.newVal('OtherOppIncome'),
                NetOperatingIncome: this.newSum('NetOperatingIncome'),
                RawMatAndCons: this.newVal('RawMatAndCons'),
                OtherExtCosts: this.newVal('OtherExtCosts'),
                PersonalCosts: this.newVal('PersonalCosts'),
                OtherOppExpenses: this.newVal('OtherOppExpenses'),
                DeprAndWriteDowns: this.newVal('DeprAndWriteDowns'),
                OperatingResult: this.newSum('OperatingResult'),
                ResultParticipationGroup: this.newVal('ResultParticipationGroup'),
                ExtInterestInc: this.newVal('ExtInterestInc'),
                FinIntGroupInc: this.newVal('FinIntGroupInc'),
                OtherFinInc: this.newVal('OtherFinInc'),
                InterestExpExt: this.newVal('InterestExpExt'),
                InterestExpInt: this.newVal('InterestExpInt'),
                OtherFinCosts: this.newVal('OtherFinCosts'),
                ProfLossAfterFinItems: this.newSum('ProfLossAfterFinItems'),
                GroupContrib: this.newVal('GroupContrib'),
                OtherAppropriations: this.newVal('OtherAppropriations'),
                Tax: this.newVal('Tax'),
                NetProfitLoss: this.newSum('NetProfitLoss'),
            },
            Balance: {
                DateFrom: this.bs.DateFrom,
                DateTo: this.bs.DateTo,
                Months: this.bs.Months,
                SubscribedCapitalUnpaid: this.newVal('SubscribedCapitalUnpaid'),
                TotalIntangibleAssets: this.newVal('TotalIntangibleAssets'),
                TotalTangibleAssets: this.newVal('TotalTangibleAssets'),
                TotalFinancialAssets: this.newVal('TotalFinancialAssets'),
                TotFixAssets: this.newSum('TotFixAssets'),
                WorkOnContract: this.newVal('WorkOnContract'),
                Inventories: this.newVal('Inventories'),
                AccountsReceivableTrade: this.newVal('AccountsReceivableTrade'),
                AccRecieveGroup: this.newVal('AccRecieveGroup'),
                OtherAccRecieve: this.newVal('OtherAccRecieve'),
                ShortInvestments: this.newVal('ShortInvestments'),
                CashAndBankBalances: this.newVal('CashAndBankBalances'),
                OtherCurAssets: this.newVal('OtherCurAssets'),
                TotalTurnoverAssets: this.newSum('TotalTurnoverAssets'),
                TotAssets: this.newSum('TotAssets'),
                TotEquity: '' + (Number(this.newVal('TotEquity')) + this.getDiff({field: 'NetProfitLoss'})),
                UntaxedReserves: this.newVal('UntaxedReserves'),
                Provisions: this.newVal('Provisions'),
                TotLongTermDebts: this.newVal('TotLongTermDebts'),
                TotCurrentLiabilities: this.newVal('TotCurrentLiabilities'),
                TotEquityAndLiab: this.newSum('TotEquityAndLiab'),
            },
        };

        const OrgNr = await api.updateSie(doc);
        await user.getUser('Uppdaterar SIE-fil');
        // user.setActiveSie(null);
        this.prev();
    }

    get canCreate() {
        return !this.hasBsDiff;
    }

    get bs() {
        if (this.sie.AccountBalanceSheet) {
            return this.sie.AccountBalanceSheet[0];
        }
        return null;
    }

    get pl() {
        if (this.sie.AccountProfitlossSheet) {
            return this.sie.AccountProfitlossSheet[0];
        }
        return null;
    }

    get hasPlDiff(): boolean {
        return this.NetProfitLossDiff !== 0;
    }

    get hasBsDiff(): boolean {
        return (this.TotAssets + this.TotAssetsDiff) !==
            (this.TotEquityAndLiab + this.TotEquityAndLiabDiff);
    }

    get bsDiff(): number {
        return (this.TotAssets + this.TotAssetsDiff) -
            (this.TotEquityAndLiab + this.TotEquityAndLiabDiff);
    }
}
